module.exports = __webpack_public_path__ + "static/media/  (72).41e2eba3.jpg";